var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ma-0 pa-0" },
    [
      _c(
        "v-layout",
        {
          attrs: {
            row: "",
            wrap: "",
            "mx-4": "",
            "pl-0": "",
            "mt-0": "",
            "mb-3": ""
          }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "", "mt-2": "" } },
                [
                  _c(
                    "v-flex",
                    [
                      _c("h1", { staticClass: "primary--text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(_vm.lblSetting.blockOverallInformations)
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs2: "" } },
                        [
                          _c("v-card", {
                            attrs: {
                              flat: "",
                              color: "secondary",
                              height: "1px",
                              width: "100%"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                {
                  attrs: {
                    "px-0": "",
                    "mt-2": "",
                    row: "",
                    wrap: "",
                    "justify-start": ""
                  }
                },
                [
                  _c(
                    "v-flex",
                    {
                      ref: "mapContainerRef",
                      staticStyle: { height: "300px" },
                      style: _vm.dtStyle,
                      attrs: { "ml-0": "", "mr-1": "" }
                    },
                    [
                      _c(
                        "gmap-map",
                        {
                          staticStyle: { height: "100%", width: "100%" },
                          attrs: {
                            center: _vm.dtCenter,
                            zoom: 10,
                            "map-type-id": "terrain"
                          }
                        },
                        [
                          _c("gmap-marker", {
                            attrs: { position: _vm.dtCenter }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      class: { xs7: _vm.isTenantPage, xs5: !_vm.isTenantPage },
                      attrs: { "ml-3": "" }
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "py-3 pr-1 md12",
                          attrs: { width: "95%" }
                        },
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: { row: "", wrap: "", "justify-start": "" }
                            },
                            [
                              _c(
                                "v-flex",
                                {
                                  class: {
                                    xs12: !_vm.isTenantPage,
                                    xs7: _vm.isTenantPage
                                  },
                                  attrs: { "pl-4": "" }
                                },
                                [
                                  !_vm.coLoader
                                    ? _c("user-profile-enhanced-widget", {
                                        attrs: { user: _vm.userContact }
                                      })
                                    : [
                                        _c("block-infos-loader", {
                                          attrs: { height: 15, width: 200 }
                                        }),
                                        _vm._v(" "),
                                        _c("block-infos-loader", {
                                          attrs: { height: 15, width: 170 }
                                        })
                                      ]
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isTenantPage &&
          _vm.entity.apartments &&
          _vm.entity.apartments.length
            ? _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "", "mt-4": "" } },
                    [
                      _c(
                        "v-flex",
                        [
                          _c("h1", { staticClass: "primary--text" }, [
                            _vm._v(
                              _vm._s(_vm.$t(_vm.lblSetting.blockOwnerAddress))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [
                              _c("v-card", {
                                attrs: {
                                  flat: "",
                                  color: "secondary",
                                  height: "1px",
                                  width: "100%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    {
                      staticClass: "user--contact__apartments",
                      attrs: { "px-0": "", "mt-2": "", row: "", wrap: "" }
                    },
                    _vm._l(_vm.entity.apartments, function(apartment, index) {
                      return _c(
                        "v-flex",
                        { key: apartment.id, attrs: { xs4: "", md3: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "mb-2 mr-2 pa-3 apartment--card" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v(
                                  "N° " + _vm._s(apartment.apartment_number)
                                )
                              ]),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v(_vm._s(apartment.type))
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                {
                                  staticClass: "mt-2",
                                  attrs: { row: "", wrap: "" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { column: "", wrap: "" } },
                                    [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v(_vm._s(apartment.block.name))
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(apartment.block.address.line1)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(apartment.block.address.line2)
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.dtMessageErrorModel
        ? _c("base-error-dialog", {
            attrs: { error: _vm.dtError },
            on: { cancel: _vm.handleCloseErrorModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenDeleteMessage
        ? _c("base-delete-dialog", {
            attrs: {
              "is-loading": _vm.dtIsLoading,
              message: _vm.coProfileDelectionMessage
            },
            on: { cancel: _vm.handleDeleteCancel, delete: _vm.handleDeleteOK }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c1e72fb6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1e72fb6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/block-tenants-detail/template.html
// module id = null
// module chunks = 